import { HeaderMenu } from '@/components/header-menu';
import { LikedList } from '@/components/liked-list';
import { useGetLikeMe } from '@/hooks/use-get-like-me';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { useTranslation } from 'react-i18next';

export const Liked = () => {
    const { data, isFetching, refetch, error } = useGetLikeMe();
    const navigate = useNavigate();

    useEffect(() => {
        if (error) {
            const axiosError = error as any;
            if (axiosError.response?.status === 403 && axiosError.response?.data?.is_banned) {
                navigate(routesApp.banned);
            }
        }
    }, [error, navigate]);

    const { t } = useTranslation();

    return (
        <>
            <HeaderMenu title={t('likes_title')} marginBottom={23} />

            <LikedList
                paidLikes={data?.data.paid ?? []}
                freeLikes={data?.data.free ?? []}
                refetchData={refetch} />
        </>
    );
};
